import { ThemeColors } from '@lyrahealth-inc/shared-app-logic'

import { getButtonStyles } from './buttonStyles'

export const getAuroraButtonStyles = (tokenColors: ThemeColors) => {
  const defaultButtonStyles = getButtonStyles(tokenColors)

  return {
    ...defaultButtonStyles,
  }
}
